<div class="form-view-index-shell" [ngClass]="currentTheme">
  <!-- index.html equivalent shell phase -->
  <div class="form-view-index-entry"></div>

  <!-- form-view-tab equivalent body phase -->
  @if (tabWrapperReady) {
    <gtw-form-view-tab>
      <!-- Top tab wrapper parity with legacy index.html -->
      <div class="pdf-tab-hdr clearfix">
        <div class="tab-set-scroller">
          <ul class="nav-tabs">
            <li id="pdf-forms"
              [class.active]="formReviewPanesVisible"
              (click)="goToFormReviewTab()">
              <div class="cont-wrapper">
                <i class="fa fa-circle" aria-hidden="true"></i>
                <span>PDF Forms</span>
              </div>
            </li>
            <li id="bulk-export-history" (click)="openBulkExportHistory()">
              <div class="cont-wrapper">
                <i class="fa fa-circle" aria-hidden="true"></i>
                <span>Bulk Export History</span>
              </div>
            </li>
            @for (tab of drilldownTabsForBar; track tab) {
              <li
                [class.active]="tab.active && !formReviewPanesVisible"
                [attr.id]="tab.code"
                (click)="activateDrilldownTab(tab)">
                <div class="cont-wrapper">
                  <i class="fa fa-circle" aria-hidden="true" [ngClass]="{cached: tab.cached, loading_data: tab.loading}"></i>
                  <span>{{ tab.code }}</span>
                  <i class="fa fa-times tab-close" (click)="closeDrilldownTab(tab, $event)" aria-label="Close tab"></i>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
      <!-- Loader -->
      @if (showFormLoader) {
        <div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
      }
      @if (!showFormLoader) {
        <div class="form-view-main">
          @if (!filterSubmitFullLoading) {
            <!-- Legacy `form-view.html` filters/toolbar — hidden on `form-view.element-view` (drilldown only). -->
            @if (formReviewPanesVisible) {
              <div class="gt-filter-container">
                <div class="filter-toolbar-row">
                  <div class="filters">
                    <div class="filter-item">
                      <select [(ngModel)]="taxYear" (ngModelChange)="changeTaxYear()" class="filter-select">
                        @for (ty of taxYears; track ty) {
                          <option [ngValue]="ty">{{ getTaxYearLabel(ty) }}</option>
                        }
                      </select>
                    </div>
                    <div class="filter-item">
                      <select [(ngModel)]="scenario" (ngModelChange)="changeScenario()" class="filter-select">
                        @for (s of scenarios; track s) {
                          <option [ngValue]="s">{{ getScenarioLabel(s) }}</option>
                        }
                      </select>
                    </div>
                    <div class="filter-actions">
                      <button class="action-btn filter-submit-btn" (click)="loadHierarchy(null, true, true)" title="Filter">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                @if (isFilterApplied) {
                  <div class="breadcrumb-toolbar-row"
                    >
                    <div class="header-info-content header-info-content--breadcrumb">
                      <i class="fa fa-id-card-o card-icon"></i>
                      <span class="breadcrumb-text">
                        Form Review{{ getTreeName() ? ' -> ' + getTreeName() : '' }}
                        {{ selectedEntity?.tax_year ? ' -> ' + selectedEntity.tax_year : '' }}
                        {{ selectedEntityBreadcrumb ? ' -> ' + selectedEntityBreadcrumb : '' }}
                        {{ selectedForm?.label ? ' -> ' + selectedForm.label : '' }}
                      </span>
                    </div>
                    <div class="header-ctrl header-ctrl--toolbar">
                      @if (runningAction) {
                        <div class="action-loader">
                          <i class="fa fa-spinner fa-spin fa-2x"></i>
                        </div>
                      }
                      @if (!runningAction) {
                        <table class="header-action-table">
                          <tr>
                            @if (canTriggerS3Process) {
                              <td
                                [class.disabled]="!taxYear || !scenario || disableS3PushButton"
                                (click)="getProcessList()">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            @if (showUpdateS3Status) {
                              <td
                                [class.disabled]="disableS3UpdateStatus"
                                (click)="updateEntityS3Status()">
                                <i class="fa fa-undo"></i>
                              </td>
                            }
                            @if (showSelectAll) {
                              <td (click)="selectAllPDFs()">
                                <i class="fa" [ngClass]="isSelectAll ? 'fa-check-square-o' : 'fa-square-o'"></i>
                              </td>
                            }
                            @if (showMerge) {
                              <td [class.disabled-btn]="!enableMerge" (click)="loadMergedPDF()">
                                <i class="fa fa-compress"></i>
                              </td>
                            }
                            @if (showExpand && pdfLoaded) {
                              <td (click)="runAction('expand')">
                                <i class="fa fa-expand"></i>
                              </td>
                            }
                            @if (selectedEntity) {
                              <td (click)="runAction('xml')">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            @if (selectedEntity) {
                              <td (click)="runAction('zip')">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            @if (irsSubmissionId) {
                              <td (click)="downloadXMLorZIPBySubmission(irsSubmissionId, 'zip')">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            @if (showExpand && pdfLoaded && (!enableReviewProcess || selectedEntity?.is_accepted === 'Y')) {
                              <td
                                (click)="runAction('download')">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            @if (showExpand && pdfLoaded && enableReviewProcess && selectedEntity?.is_accepted !== 'Y') {
                              <td
                                (click)="downloadWithSnapshot()">
                                <i class="fa fa-download"></i>
                              </td>
                            }
                            <td (click)="openBulkExportPopUp()">
                              <i class="fa fa-download"></i>
                            </td>
                          </tr>
                          <tr>
                            @if (canTriggerS3Process) {
                              <td (click)="getProcessList()">Show DOM queue</td>
                            }
                            @if (showUpdateS3Status) {
                              <td (click)="updateEntityS3Status()">Reset S3 Status</td>
                            }
                            @if (showSelectAll) {
                              <td (click)="selectAllPDFs()">{{ !isSelectAll ? 'Select All' : 'Undo' }}</td>
                            }
                            @if (showMerge) {
                              <td [class.disabled-btn]="!enableMerge" (click)="loadMergedPDF()">Merge</td>
                            }
                            @if (showExpand && pdfLoaded) {
                              <td (click)="runAction('expand')">Expand</td>
                            }
                            @if (selectedEntity) {
                              <td (click)="runAction('xml')">Download XML</td>
                            }
                            @if (selectedEntity) {
                              <td (click)="runAction('zip')">Download ZIP</td>
                            }
                            @if (irsSubmissionId) {
                              <td (click)="downloadXMLorZIPBySubmission(irsSubmissionId, 'zip')">Download Submission File</td>
                            }
                            @if (showExpand && pdfLoaded && (!enableReviewProcess || selectedEntity?.is_accepted === 'Y')) {
                              <td
                              (click)="runAction('download')">Download PDF</td>
                            }
                            @if (showExpand && pdfLoaded && enableReviewProcess && selectedEntity?.is_accepted !== 'Y') {
                              <td
                              (click)="downloadWithSnapshot()">Download PDF</td>
                            }
                            <td (click)="openBulkExportPopUp()">Bulk Export</td>
                          </tr>
                        </table>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (isFilterApplied || !formReviewPanesVisible) {
              <div class="form-view-scroll-area"
                [class.form-view-scroll-area--drilldown]="!formReviewPanesVisible">
                <!-- Drilldown Grid Tabs (legacy form-view.element-view body — replaces tree/PDF) -->
                <gtw-form-view-drilldown #drilldownGrid
                  [visible]="!formReviewPanesVisible"
                  [currentTheme]="currentTheme"
                  [GENERAL_CONFIG]="GENERAL_CONFIG"
                  [showTabBar]="false"
                  (closed)="onDrilldownClosed()"
                  (workspaceModeChange)="onDrilldownWorkspaceChange()"
                  (gridFormCallback)="onDrilldownGridFormCallback($event)">
                </gtw-form-view-drilldown>
                <!-- Main Content Area (legacy form-view.dashboard only) -->
                @if (formReviewPanesVisible) {
                  <div class="horizontal-panes">
                    @if (treePaneMinimized) {
                      <button type="button" class="tree-pane-restore"
                        (click)="openTreePane()" title="Show entity tree" aria-label="Show entity tree">
                        <span class="tree-pane-restore__disc" aria-hidden="true">
                          <i class="fa fa-bars"></i>
                        </span>
                      </button>
                    }
                    <!-- Tree View Panel -->
                    <div class="tree-view" [class.tree-view-collapsed]="treePaneMinimized">
                      <!-- Tree Search -->
                      <div class="tree-search">
                        <div class="tree-search-field-wrap">
                          <i class="fa fa-search tree-search-infield-icon" aria-hidden="true"></i>
                          <input type="search"
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="filterTreeData()"
                            placeholder="Search entities..."
                            class="search-input tree-search-field"
                            autocomplete="off"
                            spellcheck="false" />
                          </div>
                          @if (entityTree.length > 0 && !treePaneMinimized) {
                            <button type="button"
                              class="tree-pane-toggle-btn"
                              (click)="closeTreePane()"
                              title="Minimize entity tree"
                              aria-label="Minimize entity tree">
                              <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                            </button>
                          }
                        </div>
                        <div class="tree-type-tabs tree-type-tabs--sidebar">
                          <div class="tree-type-tabs__primary">
                            @for (tab of treeTypeTabs; track tab) {
                              <button
                                type="button"
                                class="tree-tab"
                                [class.active]="tab.value === treeType"
                                [disabled]="tab.disabled"
                                (click)="loadHierarchy(tab)">
                                {{ tab.name }}
                              </button>
                            }
                          </div>
                          @if (treeType === 'BSLA') {
                            <div class="tree-type-tabs__bsla">
                              @for (bTab of bslaTypeTabs; track bTab) {
                                <button
                                  type="button"
                                  class="bsla-tab"
                                  [class.active]="bTab.value === bslaType"
                                  (click)="bslaType = bTab.value; loadHierarchy(null, true)">
                                  {{ bTab.name }}
                                </button>
                              }
                            </div>
                          }
                        </div>
                        <div class="tree-record-count"
                          [class.tree-record-count--loading]="loadingEntities">
                          <!-- Legacy form-view.html: plus = collapsed (expandAll false), minus = expanded (expandAll true); click toggles. -->
                          @if (!loadingEntities && entityTree.length > 0 && !entityTree[0]?.noDataFlag) {
                            <button type="button"
                              class="tree-record-count__toggle"
                              (click)="expandCollapseAll()"
                              [title]="expandAllTxt"
                              [attr.aria-label]="expandAllTxt">
                              <i class="fa tree-record-count__icon all-toggle hover-override"
                                [ngClass]="expandAll ? 'fa-minus-circle' : 'fa-plus-circle'"
              [ngStyle]="{
                color: currentTheme === 'theme-white' ? '#c25423' : '#cd5763',
                'padding-right.px': expandAll ? 4 : 3
              }"
                              aria-hidden="true"></i>
                            </button>
                          }
                          <span class="tree-record-count__text">
                            @if (loadingEntities) {
                              <i class="fa fa-spinner fa-spin tree-record-count__spinner" aria-hidden="true"></i>
                              <span class="tree-record-count__loading-label">Loading…</span>
                            }
                            @if (!loadingEntities && entityTree.length > 0 && !entityTree[0]?.noDataFlag) {
                              Total No. of records: {{ getVisibleTreeRowCount() }}
                            }
                            @if (!loadingEntities && (!entityTree.length || entityTree[0]?.noDataFlag)) {
                              Total No. of records: 0
                            }
                          </span>
                        </div>
                        <!-- Tree List -->
                        @if (!loadingEntities && entityTree.length > 0) {
                          <div class="tree-list">
                            @for (item of entityTree; track trackByFn($index, item)) {
                              @if (visibleNodes(item)) {
                                <div class="tree-item"
                                  [attr.data-parent]="item.parent"
                                  [attr.data-is-entity]="item.is_entity"
                                  [attr.data-is-gtw-view]="!isState"
                                  [style.padding-left.px]="(item.lvl || 0) * 20 + 10"
                                  [class.selected]="isEntitySelected(item)"
                                  [class.no-data]="item.noDataFlag">
                                  <!-- Legacy (ui/app/components/formView/form-view.html line 1282):
                                  `<span class="irs" ng-if="item.is_entity && item.is_accepted === 'Y'"
                                ng-style="left:calc(19px * {{item.lvl}})">IRS</span>`
                                Rendered for filed/accepted entities ALONGSIDE the `fa fa-check`
                                icon returned by `getIconClass(item)`. Positioned 1px left of where
                                the check icon starts so the badge overlays its top-left corner. -->
                                @if (item.is_entity && item.is_accepted === 'Y') {
                                  <span class="irs"
                                  [style.left.px]="(item.lvl || 0) * 20 + 9">IRS</span>
                                }
                                <!-- Legacy (line 1283): `<i class="toggle fa" ng-class="getIconClass(item)"
                                ng-style="{color: lvl > 0 ? accent : '#000'}">`.
                                For is_leaf + is_entity + is_accepted === 'Y', getIconClass returns
                                `fa fa-check toggle`, giving the filed-entity checkmark that pairs
                                with the IRS badge above. -->
                                @if (!item.noDataFlag) {
                                  <i class="toggle fa tree-icon"
                                    [ngClass]="getIconClass(item)"
                                    [ngStyle]="{ color: getTreeIconColor(item) }"
                                    (click)="toggleNode(item)"
                                  ></i>
                                }
                                <a class="tree-label hover-override"
                                  [class.disable-click]="item.noDataFlag"
                                  (click)="onTreeLabelClick(item)"
                                  [title]="getTreeNodeTooltip(item)">
                                  {{ getTreeNodeDisplayLabel(item) }}
                                </a>
                                @if (item.is_entity && item.isCached) {
                                  <span class="irs-badge">
                                    <i class="fa fa-bookmark"></i>
                                  </span>
                                }
                                <!-- Legacy hover action buttons for Subsidiaries / Parent entity rows:
                                `<button .filter-selection>All HO</button><button .filter-selection>HO Only</button>` -->
                                @if (shouldShowSubsidiaryActions(item)) {
                                  <div class="tree-subsidiary-actions"
                                    >
                                    <button type="button"
                                      class="tree-subsidiary-btn theme-accent"
                                      [class.active]="isAllHoActive(item)"
                                      (click)="selectSubsidiaryType(item, 'HO', $event)">
                                      All HO
                                    </button>
                                    <button type="button"
                                      class="tree-subsidiary-btn theme-accent active"
                                      [class.not-active]="isAllHoActive(item)"
                                      (click)="selectSubsidiaryType(item, 'HOO', $event)">
                                      HO Only
                                    </button>
                                  </div>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                    <div class="form-pdf-pane">
                      @if (messageTxt) {
                        <div class="form-panel-message-bar"
                          [class.form-panel-message-bar--complete]="messageComplete"
                          [class.form-panel-message-bar--warn]="messageWarn">
                          @if (!messageComplete && !messageWarn) {
                            <span class="form-panel-message-bar__glyph" aria-hidden="true">
                              <i class="fa fa-spinner fa-spin"></i>
                            </span>
                          }
                          @if (messageComplete) {
                            <span class="form-panel-message-bar__glyph form-panel-message-bar__glyph--success" aria-hidden="true">
                              <i class="fa fa-check"></i>
                            </span>
                          }
                          @if (messageWarn && !messageComplete) {
                            <span class="form-panel-message-bar__glyph form-panel-message-bar__glyph--warn" aria-hidden="true">
                              <i class="fa fa-exclamation-triangle"></i>
                            </span>
                          }
                          <span class="form-panel-message-bar__text">{{ messageTxt }}</span>
                        </div>
                      }
                      <div class="form-pdf-row">
                        <!-- Forms Panel (PDF tiles + search): status bar above search, legacy shell parity -->
                        <div class="form-view" [class.form-view-collapsed]="isPdfViewerOpen()">
                          @if (pdfs.length > 0 && !loadingEntities) {
                            <div class="form-toolbar">
                              <div class="form-search-wrap">
                                <i class="fa fa-search form-search-icon" aria-hidden="true"></i>
                                <input type="search"
                                  [(ngModel)]="formSearchTerm"
                                  placeholder="Search forms..."
                                  class="search-input form-search-input"
                                  autocomplete="off"
                                  spellcheck="false" />
                                </div>
                              </div>
                            }
                            <div class="form-view-content">
                              @if (loadingEntities) {
                                <div class="form-pane-hierarchy-hint">
                                  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                  <span>Loading data…</span>
                                </div>
                              }
                              @if (!loadingEntities) {
                                <!-- Form Loading -->
                                @if (loadingForms) {
                                  <div class="form-loader form-loader--pane">
                                    <i class="fa fa-spinner fa-spin"></i>
                                    <span>Loading forms...</span>
                                  </div>
                                }
                                <!-- No Forms Message -->
                                @if (!loadingForms && noFormsMsg) {
                                  <div class="no-forms">
                                    {{ noFormsMsg }}
                                  </div>
                                }
                                <!-- Form List -->
                                @if (!loadingForms && pdfs.length > 0) {
                                  <div class="form-list form-list--grid">
                                    @for (pdf of pdfs; track trackByLabelFn($index, pdf)) {
                                      @if (formFilter(pdf)) {
                                        <div class="form-item form-item--tile"
                                          [class.selected]="pdf === selectedForm">
                                          <div class="form-file-icon"
                                            [class.form-file-icon--pdf-image]="isPdfFileBadge(pdf)"
                                            [class.form-file-icon--wpd-image]="isWpdFileBadge(pdf)"
                                            [class.form-file-icon--bin-image]="isBinFileBadge(pdf)"
                                            [attr.data-kind]="getFormFileBadge(pdf)"
                                            (click)="loadPDF(pdf)">
                                            @if (isPdfFileBadge(pdf)) {
                                              <img
                                                [src]="pdfBadgeIconSrc"
                                                alt="PDF"
                                                class="form-file-icon__img" />
                                            }
                                            @if (!isPdfFileBadge(pdf) && !isWpdFileBadge(pdf) && !isBinFileBadge(pdf)) {
                                              <span class="form-file-icon__label">
                                                {{ getFormFileBadge(pdf) }}
                                              </span>
                                            }
                                          </div>
                                          <label class="form-checkbox form-checkbox--tile">
                                            <input type="checkbox" [(ngModel)]="pdf.checked" (change)="selectForm()" />
                                            <span class="form-label"
                                              (click)="loadPDF(pdf)"
                                              (mouseenter)="onFormLabelMouseEnter($event, pdf.label)">
                                              {{ pdf.label }}
                                            </span>
                                          </label>
                                        </div>
                                      }
                                    }
                                  </div>
                                }
                              }
                            </div>
                          </div>
                          <!-- PDF Viewer Panel -->
                          @if (isPdfViewerOpen()) {
                            <div class="pdf-container">
                              <!-- PDF Actions (fixed; scroll only in .pdf-body below) -->
                              <!-- <div class="pdf-toolbar">
                              <button class="action-btn-sm" (click)="toggleExpandPdf()">
                                <i class="fa fa-compress"></i>
                              </button>
                              <button class="action-btn-sm" *ngIf="showExpand && pdfLoaded && (!enableReviewProcess || selectedEntity?.is_accepted === 'Y')"
                                (click)="runAction('download')">
                                <i class="fa fa-download"></i> Download
                              </button>
                              <button class="action-btn-sm" *ngIf="showExpand && pdfLoaded && enableReviewProcess && selectedEntity?.is_accepted !== 'Y'"
                                (click)="downloadWithSnapshot()">
                                <i class="fa fa-download"></i> Download
                              </button>
                            </div> -->
                            <div class="pdf-body">
                              <!-- PDF Loading -->
                              @if (pdfLoading) {
                                <div class="pdf-loader">
                                  <i class="fa fa-spinner fa-spin"></i> Loading PDF...
                                </div>
                              }
                              <!-- PDF Not Available -->
                              @if (!pdfLoading && formNotAvail) {
                                <div class="pdf-not-available">
                                  PDF not available for this form.
                                </div>
                              }
                              <!-- PDF Iframe -->
                              @if (!pdfLoading && pdfUrl && !formNotAvail) {
                                <iframe
                                  [src]="pdfUrl"
                                  class="pdf-frame"
                                  frameborder="0">
                                </iframe>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <!-- Bulk Export Modal -->
                    <gtw-bulk-export
                      [visible]="showBulkExport"
                      [entityTreeData]="entityTreeCopy"
                      [taxYear]="taxYear"
                      [scenario]="scenario"
                      [jcdKey]="JCD_KEY"
                      [contSrc]="SRC"
                      [currentTheme]="currentTheme"
                      [enableReviewProcess]="bulkExportReviewProcess"
                      [USER_SETTINGS]="USER_SETTINGS"
                      [pdfEngineUrl]="pdfEngineUrl"
                      [bulkPdfUrl]="bulkPdfUrl"
                      (closed)="closeBulkExport()"
                      (openDiagnostics)="onOpenDiagnostics($event)">
                    </gtw-bulk-export>
                    <!-- Review Diagnostics Modal -->
                    <gtw-review-diagnostics-modal
                      [visible]="showReviewDiagnostics"
                      [params]="reviewDiagParams"
                      [currentTheme]="currentTheme"
                      (dismissed)="onDiagnosticsDismissed()"
                      (completed)="onDiagnosticsCompleted($event)"
                      (navigateToDiagnostics)="onNavigateToDiagnostics($event)">
                    </gtw-review-diagnostics-modal>
                    <!-- S3 Template View Modal -->
                    <gtw-s3-template-view
                      [visible]="showS3TemplateView"
                      [rowData]="s3TemplateRowData"
                      [currentTheme]="currentTheme"
                      [GENERAL_CONFIG]="GENERAL_CONFIG"
                      [USER_SETTINGS]="USER_SETTINGS"
                      [taxYear]="taxYear?.label || taxYear?.value || ''"
                      (closed)="showS3TemplateView = false"
                      (refreshGrid)="refresh()">
                    </gtw-s3-template-view>
                  </div>
                }
              </div>
            }
          }
          @if (filterSubmitFullLoading) {
            <div class="form-view-filter-loading">
              <i class="fa fa-spinner fa-spin gt-refresh" aria-hidden="true"></i>
              <span>Loading data…</span>
            </div>
          }
        </div>
      }
    </gtw-form-view-tab>
  }
</div>
